import React from 'react';
export function UrgencyBar() {
  return <div className="fixed top-0 left-0 w-full bg-red-700 text-white text-xs md:text-sm font-medium py-2 px-4 text-center z-50 shadow-md" data-id="element-170">
      <span className="font-bold tracking-wider" data-id="element-171">SOLO PARA EJECUTORES:</span>{' '}
      Esta oferta de compromiso único está limitada a la cohorte actual. Si no
      estás listo para actuar, por favor deja este lugar a quien sí lo esté.
    </div>;
}